// Generates a clean, brand-matched PDF version of the WearSpray pitch deck.
// Drawn with jsPDF's vector text/shape primitives, with a small set of real
// product/proof photos embedded alongside the text on select slides.
import { jsPDF } from "jspdf";
import { SLIDES, SLIDE_IMAGES } from "./slidesData";
import { loadImageBox, W, H } from "./drawHelpers";
import { drawSlide } from "./drawSlide";

export async function generatePitchDeckPdf() {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [W, H] });
  doc.setProperties({
    title: "WearSpray \u2014 Investor Pitch Deck",
    subject: "WearSpray seed round investor presentation",
    author: "WearSpray",
    creator: "WearSpray",
  });
  const loaded = await Promise.all(
    Object.entries(SLIDE_IMAGES).map(async ([n, cfg]) => {
      try {
        const box = await loadImageBox(cfg.url);
        return [n, { ...cfg, ...box }];
      } catch (err) {
        console.warn("Pitch deck PDF: image failed to load, skipping", cfg.url, err);
        return [n, null];
      }
    })
  );
  const imagesByNum = Object.fromEntries(loaded.filter(([, v]) => v));
  SLIDES.forEach((slide, i) => drawSlide(doc, slide, i === 0, imagesByNum[slide.n], SLIDES.length));
  doc.save("WearSpray-Pitch-Deck.pdf");
}
